import { createContext } from 'react';
type IDisclaimerContext = {
  isDisclaimerVisible: boolean;
  setIsDisclaimerVisible: (value: boolean) => void;
};
export const DisclaimerContext = createContext<IDisclaimerContext>({
  isDisclaimerVisible: false,
  setIsDisclaimerVisible: () => {
    console.warn('setIsDisclaimerVisible is called');
  },
});
